import { __assign } from "tslib";
import { styled, ToggleButtonGroup as MuiToggleButtonGroup, } from '@mui/material';
import { alpha } from '@mui/system';
export var StyledToggleButtonGroup = styled(MuiToggleButtonGroup, {
    shouldForwardProp: function (prop) { return !['variant', 'color'].includes(String(prop)); },
})(function (_a) {
    var theme = _a.theme, variant = _a.variant, size = _a.size, color = _a.color;
    return (__assign(__assign({}, (variant === 'views mode' && {
        padding: theme.spacing(0.5),
        border: 0,
        backgroundColor: theme.palette.greySecondary[50],
        "&.Mui-disabled": {
            border: 0
        },
        '& .MuiToggleButton-root': {
            position: "relative",
            border: "none",
            width: size === 'small' ? 24 : 32,
            height: size === 'small' ? 24 : 32,
            "&:hover": {
                backgroundColor: alpha(theme.palette.greySecondary.main, 0.08)
            },
            '&:after': {
                content: '""',
                position: "absolute",
                left: 2,
                top: 2,
                right: 2,
                bottom: 2,
                transition: "transform 0.3s linear",
            },
            '&:first-of-type': {
                borderRadius: "100%",
                '&:after': {
                    transform: "translateX(100%)",
                },
            },
            '&:last-of-type': {
                borderRadius: "100%",
                '&:after': {
                    transform: "translateX(-100%)",
                },
            },
            '&.Mui-selected': {
                backgroundColor: "transparent",
                '&:hover': {
                    backgroundColor: "transparent",
                },
                '&:after': {
                    backgroundColor: theme.palette.common.white,
                    transform: "translateX(0)",
                    borderRadius: 2,
                    boxShadow: "0 2px 4px 0 rgba(0, 0, 0, 0.16)",
                },
            },
            svg: {
                position: "relative",
                zIndex: 1,
                fontSize: size === 'small' ? 16 : 24,
            }
        }
    })), (color && {
        '.MuiToggleButton-root': {
            '&.Mui-selected': {
                color: theme.palette[color].contrastText,
                borderColor: theme.palette[color].main,
                backgroundColor: theme.palette[color].main,
                '&:hover': {
                    backgroundColor: theme.palette[color].main,
                }
            }
        }
    })));
});
//# sourceMappingURL=styled.js.map